import { createContext } from "react";

/** The `AuthContext` context value. */
export interface AuthContextValue {

  /** The currently logged in user's authentication token. `null` if not logged in. */
  readonly authToken: string | null;

  /** The currently logged in user's authentication refresh token. `null` if not logged in. */
  readonly authRefreshToken: string | null;

  /** Sets the current authentication token. */
  readonly setAuthToken: (authToken: string | null) => void;

  /** Sets the current auhentication refresh token. */
  readonly setAuthRefreshToken: (authToken: string | null) => void;

  /** The current user permissions. */
  readonly permissions: ReadonlyArray<string>;

  /** Sets the current set of shell permissions. */
  readonly setPermissions: (permissions: ReadonlyArray<string>) => void;
}

/** The capitalrx shell authentication context. */
export const AuthContext = createContext<AuthContextValue>({
  authToken: null,
  authRefreshToken: null,
  setAuthToken: () => {},
  setAuthRefreshToken: () => {},
  permissions: [],
  setPermissions: () => {},
});
